import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DurchsuchenServiceModule } from '..';
import { DurchsuchenFilterComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    DurchsuchenServiceModule
  ],
  declarations: [DurchsuchenFilterComponent],
  exports: [DurchsuchenFilterComponent],

})
export class DurchsuchenFilterComponentModule { }
